/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BookingCampaignPhoto,
  DiscreteFacetSpaceFacetPageValue,
  MultipleSpacesAvailabilityRequest,
  PageResponseSpaceResponse,
  SpaceFacetResponse,
  SpaceFilterResponse,
  SpaceRequestDataWithFiles,
  SpaceResponse,
  SpacesRequest,
  SpaceSupportPictureResponse,
  SpaceTimelineRequest,
  SpaceTimelineResponse,
  SupportPictureResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Spaces<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags space-controller
   * @name AddSpace
   * @request POST:/spaces
   * @secure
   * @response `200` `SpaceResponse` OK
   */
  addSpace = (data: SpaceRequestDataWithFiles, params: RequestParams = {}) =>
    this.request<SpaceResponse, any>({
      path: `/spaces`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name GetSpaceGeometry
   * @summary Get Space Geometry
   * @request GET:/spaces/{spaceId}/geometry
   * @secure
   * @response `200` `string` OK
   */
  getSpaceGeometry = (spaceId: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/spaces/${spaceId}/geometry`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name UpdateSpaceGeometry
   * @summary Update Space Geometry
   * @request POST:/spaces/{spaceId}/geometry
   * @secure
   * @response `200` `string` OK
   */
  updateSpaceGeometry = (
    spaceId: string,
    data: string,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/spaces/${spaceId}/geometry`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name GetSpaceArtworkGeometry
   * @summary Get Space Artwork Geometry
   * @request GET:/spaces/{spaceId}/artworkGeometry
   * @secure
   * @response `200` `string` OK
   */
  getSpaceArtworkGeometry = (spaceId: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/spaces/${spaceId}/artworkGeometry`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name UpdateSpaceArtworkGeometry
   * @summary Update Space Artwork Geometry
   * @request POST:/spaces/{spaceId}/artworkGeometry
   * @secure
   * @response `200` `string` OK
   */
  updateSpaceArtworkGeometry = (
    spaceId: string,
    data: string,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/spaces/${spaceId}/artworkGeometry`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name GetSpacesTimeline
   * @summary Space occupancy timeline
   * @request POST:/spaces/timeline
   * @secure
   * @response `200` `SpaceTimelineResponse` OK
   */
  getSpacesTimeline = (
    data: SpaceTimelineRequest,
    params: RequestParams = {},
  ) =>
    this.request<SpaceTimelineResponse, any>({
      path: `/spaces/timeline`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name ListSpaces
   * @request POST:/spaces/getSpaces
   * @secure
   * @response `200` `PageResponseSpaceResponse` OK
   */
  listSpaces = (data: SpacesRequest, params: RequestParams = {}) =>
    this.request<PageResponseSpaceResponse, any>({
      path: `/spaces/getSpaces`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name GetSpaceFacets
   * @summary Get Space Facets
   * @request POST:/spaces/getSpaces/filters
   * @secure
   * @response `200` `SpaceFacetResponse` OK
   */
  getSpaceFacets = (data: SpacesRequest, params: RequestParams = {}) =>
    this.request<SpaceFacetResponse, any>({
      path: `/spaces/getSpaces/filters`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name GetSpaceFacetPage
   * @summary Get One Space Facet Page
   * @request POST:/spaces/getSpaces/filters/{facetGroup}
   * @secure
   * @response `200` `DiscreteFacetSpaceFacetPageValue` OK
   */
  getSpaceFacetPage = (
    facetGroup:
      | "MONTHLY_PRICE"
      | "PROPERTY_TYPE"
      | "CITY"
      | "LOCATION"
      | "SUPPORT_TYPE"
      | "EXPOSURE_TYPE"
      | "SUPPORT_NAME"
      | "PLACEMENT_AREA",
    data: SpacesRequest,
    query?: {
      /**
       * @format int32
       * @min 0
       * @max 10000
       * @default 0
       */
      offset?: number;
      /**
       * @format int32
       * @min 1
       * @max 200
       * @default 50
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<DiscreteFacetSpaceFacetPageValue, any>({
      path: `/spaces/getSpaces/filters/${facetGroup}`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name AddSpaceDraft
   * @request POST:/spaces/drafts
   * @secure
   * @response `200` `SpaceResponse` OK
   */
  addSpaceDraft = (
    data: SpaceRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<SpaceResponse, any>({
      path: `/spaces/drafts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name CountSpaces
   * @request POST:/spaces/count
   * @secure
   * @response `200` `number` OK
   */
  countSpaces = (data: SpacesRequest, params: RequestParams = {}) =>
    this.request<number, any>({
      path: `/spaces/count`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description DEPRECATED FORM — the endpoint stays, the windowless call does not. Omitting the window answers free days over the inventory's whole lifetime, which reads the past without passing the past-window gate. Send the window: it is optional today for backward compatibility and becomes MANDATORY in the next release. A window that starts in the past is refused with 403 to ADVERTISER and SERVICES callers who do not hold permission:global:create:past-bookings.
   *
   * @tags space-controller
   * @name GetMultipleSpacesAvailabilityResource
   * @summary Common availability days across several spaces
   * @request POST:/spaces/availability
   * @deprecated
   * @secure
   * @response `200` `(string)[]` OK
   */
  getMultipleSpacesAvailabilityResource = (
    data: MultipleSpacesAvailabilityRequest,
    params: RequestParams = {},
  ) =>
    this.request<string[], any>({
      path: `/spaces/availability`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name ShowSpace
   * @request GET:/spaces/{spaceId}
   * @secure
   * @response `200` `SpaceResponse` OK
   */
  showSpace = (
    spaceId: string,
    query?: {
      /** @format date-time */
      start?: string;
      /** @format date-time */
      end?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SpaceResponse, any>({
      path: `/spaces/${spaceId}`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name DeleteSpace
   * @request DELETE:/spaces/{spaceId}
   * @secure
   * @response `200` `SpaceResponse` OK
   */
  deleteSpace = (spaceId: string, params: RequestParams = {}) =>
    this.request<SpaceResponse, any>({
      path: `/spaces/${spaceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name UpdateSpace
   * @request PATCH:/spaces/{spaceId}
   * @secure
   * @response `200` `SpaceResponse` OK
   */
  updateSpace = (
    spaceId: string,
    data: SpaceRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<SpaceResponse, any>({
      path: `/spaces/${spaceId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name UnpublishSpace
   * @request PATCH:/spaces/{spaceId}/unpublish
   * @secure
   * @response `200` `SpaceResponse` OK
   */
  unpublishSpace = (spaceId: string, params: RequestParams = {}) =>
    this.request<SpaceResponse, any>({
      path: `/spaces/${spaceId}/unpublish`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name DeleteSpaceDraft
   * @request DELETE:/spaces/drafts/{spaceId}
   * @secure
   * @response `200` `SpaceResponse` OK
   */
  deleteSpaceDraft = (spaceId: string, params: RequestParams = {}) =>
    this.request<SpaceResponse, any>({
      path: `/spaces/drafts/${spaceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name UpdateSpaceDraft
   * @request PATCH:/spaces/drafts/{spaceId}
   * @secure
   * @response `200` `SpaceResponse` OK
   */
  updateSpaceDraft = (
    spaceId: string,
    data: SpaceRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<SpaceResponse, any>({
      path: `/spaces/drafts/${spaceId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name DownloadSpaceDocument
   * @summary Download Space Document
   * @request GET:/spaces/{spaceId}/thumbnails/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadSpaceDocument = (
    spaceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/spaces/${spaceId}/thumbnails/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name GetSupportPictures
   * @request GET:/spaces/{spaceId}/supportPictures
   * @secure
   * @response `200` `SupportPictureResponse` OK
   */
  getSupportPictures = (spaceId: string, params: RequestParams = {}) =>
    this.request<SupportPictureResponse, any>({
      path: `/spaces/${spaceId}/supportPictures`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name DownloadSupportPictures
   * @summary Download Space Support Pictures
   * @request GET:/spaces/{spaceId}/supportPictures/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadSupportPictures = (
    spaceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/spaces/${spaceId}/supportPictures/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name DownloadSpaceLayoutSketches
   * @summary Download Space Document
   * @request GET:/spaces/{spaceId}/layoutSketches/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadSpaceLayoutSketches = (
    spaceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/spaces/${spaceId}/layoutSketches/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name DownloadSpaceDocuments
   * @summary Download Space Documents
   * @request GET:/spaces/{spaceId}/documents
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadSpaceDocuments = (spaceId: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/spaces/${spaceId}/documents`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name DownloadSpaceDocument1
   * @summary Download Space Document
   * @request GET:/spaces/{spaceId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadSpaceDocument1 = (
    spaceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/spaces/${spaceId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name DeleteSpaceDocument
   * @summary Delete Space Document
   * @request DELETE:/spaces/{spaceId}/documents/{documentId}
   * @secure
   * @response `200` `SpaceResponse` OK
   */
  deleteSpaceDocument = (
    spaceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<SpaceResponse, any>({
      path: `/spaces/${spaceId}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name GetCampaignPhotos
   * @request GET:/spaces/{spaceId}/campaignPhotos
   * @secure
   * @response `200` `(BookingCampaignPhoto)[]` OK
   */
  getCampaignPhotos = (spaceId: string, params: RequestParams = {}) =>
    this.request<BookingCampaignPhoto[], any>({
      path: `/spaces/${spaceId}/campaignPhotos`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name DownloadSpaceCampaignPhoto
   * @summary Download Space Campaign Photo
   * @request GET:/spaces/{spaceId}/campaignPhotos/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadSpaceCampaignPhoto = (
    spaceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/spaces/${spaceId}/campaignPhotos/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description DEPRECATED FORM — the endpoint stays, the windowless call does not. Omitting the window answers free days over the inventory's whole lifetime, which reads the past without passing the past-window gate. Send the window: it is optional today for backward compatibility and becomes MANDATORY in the next release. A window that starts in the past is refused with 403 to ADVERTISER and SERVICES callers who do not hold permission:global:create:past-bookings.
   *
   * @tags space-controller
   * @name GetSpaceAvailabilityResource
   * @summary Space availability days
   * @request GET:/spaces/{spaceId}/availability
   * @deprecated
   * @secure
   * @response `200` `(string)[]` OK
   */
  getSpaceAvailabilityResource = (
    spaceId: string,
    query?: {
      /**
       * Optional today, MANDATORY from the next release. Supplied windows are gated: a past-dated start needs permission:global:create:past-bookings unless the caller is LOCATION or BACKOFFICE.
       * @format date-time
       */
      start?: string;
      /**
       * Optional today, MANDATORY from the next release. Supplied windows are gated: a past-dated start needs permission:global:create:past-bookings unless the caller is LOCATION or BACKOFFICE.
       * @format date-time
       */
      end?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string[], any>({
      path: `/spaces/${spaceId}/availability`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags space-controller
   * @name GetSpaceSupportNamePictures
   * @request GET:/spaces/supportNames/pictures
   * @secure
   * @response `200` `(SpaceSupportPictureResponse)[]` OK
   */
  getSpaceSupportNamePictures = (params: RequestParams = {}) =>
    this.request<SpaceSupportPictureResponse[], any>({
      path: `/spaces/supportNames/pictures`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Superseded by POST /spaces/getSpaces/filters (facet counts under the caller's own selection). This endpoint no longer narrows by a request body and returns the unfiltered vocabulary only; it is removed once the frontend has cut over.
   *
   * @tags space-controller
   * @name GetSpacesFilters
   * @summary Get Space Filter Values
   * @request GET:/spaces/filters
   * @deprecated
   * @secure
   * @response `200` `SpaceFilterResponse` OK
   */
  getSpacesFilters = (params: RequestParams = {}) =>
    this.request<SpaceFilterResponse, any>({
      path: `/spaces/filters`,
      method: "GET",
      secure: true,
      ...params,
    });
}
